import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";
import Modal from "../../../components/common/Modal";
import { useEffect } from "react";
import axiosMain from "../../../http/axios/axios_main";
import CustomToast from "../../../components/Toast";
import { useState } from "react";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import axios from "axios";
import { useLoader } from "../../../components/common/Loder/Loder";
import Modals from "../../../components/common/Modal";

function isDecimal(value) {
  // Ensure the value is a number
  if (typeof value !== "number") {
    return false;
  }
  // Check if the value has a decimal part
  return value % 1 !== 0;
}

const UpdateValuation = ({
  openUploadUpdateValuation,
  setOpenUploadUpdateValuation,
  getDataByPrems,
  setGetDataByprems,
  auctionCatalogDetail,
  auctioncatalogIdforupload,
  baseUrlEng,
  kutchaCatalog,
  resetgetmycatalog,
  saleProgramId,
  resetgetkuchacatalog,
  userRole,
}) => {
  const { auctionDetailId, auctionCenterUserId, auctionCenterId, userId } =
    useAuctionDetail();

  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const [group, setGroupCode] = useState([]);
  const [mkCode, setMkCode] = useState([]);
  const [sessiontyp, setsessiontyp] = useState([]);
  const [openModalConformationTitle, setOpenModalConformationTitle] =
    useState("");
  const [openModalConformation, setOpenModalConformation] = useState(false);
  const [dataFlag, setDataFlag] = useState(false);
  const [myCatalogForAuctioneer, setMyCatalogForAuctioneer] = useState(
    userRole === "buyer"
      ? [
        // { title: "Season", name: "season" },
        // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
        // { title: "Mark", name: "markName", noneditable: true, type: "text" },
        {
          title: "Lot No",
          name: "lotNo",
          noneditable: true,
          type: "text",
        },
        { title: "Mark", name: "markName", noneditable: true, type: "text" },
        {
          title: "Grade",
          name: "gradeName",
          noneditable: true,
          type: "text",
        },
        {
          title: "My Valuation",
          name: "myValuation",
          noneditable: false,
          type: "number",
        },
        {
          title: "My Comments",
          name: "myComments",
          noneditable: false,
          type: "text",
        },
        {
          title: "Group Code",
          name: "groupCode",
          noneditable: true,
          type: "select",
        },
      ]
      : baseUrlEng === "AuctionCatalog"
        ? [
          // { title: "Season", name: "season" },
          // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
          { title: "Mark", name: "Mark", noneditable: true, type: "text" },
          {
            title: "Lot No",
            name: "LotNo",
            noneditable: true,
            type: "text",
          },
          {
            title: "Base Price *",
            name: "basePrice",
            noneditable: false,
            type: "number",
          },
          {
            title: "Reserve Price *",
            name: "reservePrice",
            noneditable: false,
            type: "number",
          },
          {
            title: "Auctioneer's Valuation *",
            name: "auctioneerValuation",
            noneditable: false,
            type: "number",
          },

          // { title: "Auction Date", name: "auctionDate" },
          // { title: "Auction Date", name: "auctionDate" },
          // { title: "Tea Type", name: "teaTypeName" },
          // { title: "Category", name: "categoryName" },
          // { title: "Session Time", name: "sessionTime" },
          // { title: "Lot No.", name: "LotNo" },
          // { title: "Invoice No.", name: "invoiceNo" },
          // { title: "Origin", name: "Origin" },
          // { title: "Tea Type", name: "teaTypeName" },
          // { title: "Sub Type", name: "subTeaTypeName" },
          // { title: "Category", name: "categoryName" },
          // { title: "Grade", name: "gradeName" },
          // { title: "No. of Packages", name: "noOfPackages" },
          {
            title: "Mark & Packaging Comments",
            name: "markPackageComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Lot Comments",
            name: "lotComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Gross Weight *",
            name: "grossKgs",
            noneditable: false,
            type: "number",
          },
          {
            title: "Tare Weight *",
            name: "tareKgs",
            noneditable: false,
            type: "number",
          },
          {
            title: "Package No. *",
            name: "packageNo",
            noneditable: false,
            type: "text",
          },
          {
            title: "Total Packages *",
            name: "totalPackages",
            noneditable: false,
            type: "number",
          },
          // { title: "Net Weight", name: "netKgs" },
          {
            title: "Sample Qty. (KGs)",
            name: "SampleQty",
            noneditable: false,
            type: "number",
          },
          {
            title: "Quality Comments",
            name: "qualityComments",
            noneditable: false,
            type: "text",
          },
          // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
          // { title: "GP No.", name: "gpNo",noneditable:false },
          // { title: "GP Date", name: "gpDate",noneditable:false },
          // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
          {
            title: "Price Increment *",
            name: "priceIncrement",
            noneditable: false,
            type: "number",
          },
          // { title: "Market Type", name: "marketTypeName",noneditable:false },
          // { title: "Package Type", name: "packageType",noneditable:false },
          // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
          {
            title: "Garden Certification *",
            name: "gardenCertification",
            noneditable: false,
            type: "text",
          },
          {
            title: "Quality Certification",
            name: "qualityCertification",
            noneditable: false,
            type: "text",
          },
          {
            title: "Age of the Tea (In Months) *",
            name: "ageOfProducts",
            noneditable: false,
            type: "number",
          },
          {
            title: "Color of Brew",
            name: "brewColor",
            noneditable: false,
            type: "text",
          },
          // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
          {
            title: "Brewers Comments",
            name: "brewersComments",
            noneditable: false,
            type: "text",
          },
          // {
          //   title: "System Base Price",
          //   name: "SystemBasePrice",
          //   noneditable: true,
          //   type: "number",
          // },
          { title: "LSP / SP", name: "LSP_SP", noneditable: true },
          { title: "System Base Price", name: "SBP", noneditable: true },
          {
            title: "Short Excess Weight",
            name: "shortExcessWeight",
            noneditable: true,
            type: "text",
          },
        ]
        : baseUrlEng === "EnglishAuctionCatalog"
          ? // baseUrlEng === "EnglishAuctionKutchaCatalogue"
          [
            // { title: "Season", name: "season" },
            // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
            // { title: "Mark", name: "markName", noneditable: true, type: "text" },
            {
              title: "Lot No",
              name: "LotNo",
              noneditable: true,
              type: "text",
            },
            {
              title: "Mark",
              name: "markName",
              noneditable: true,
              type: "select",
            },
            {
              title: "Base Price",
              name: "basePrice",
              noneditable: false,
              type: "number",
            },
            {
              title: "Reserve Price",
              name: "reservePrice",
              noneditable: false,
              type: "number",
            },
            {
              title: "Auctioneer's Valuation",
              name: "auctioneerValuation",
              noneditable: false,
              type: "number",
            },

            {
              title: "Session Type",
              name: "sessionTypeName",
              noneditable: true,
              type: "select",
            },
            {
              title: "Mark & Packaging Comments",
              name: "markPackageComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Lot Comments",
              name: "lotComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Gross Weight",
              name: "grossKgs",
              noneditable: false,
              type: "number",
            },
            {
              title: "Tare Weight",
              name: "tareKgs",
              noneditable: false,
              type: "number",
            },
            {
              title: "Category",
              name: "categoryName",
              noneditable: true,
              type: "text",
            },
            {
              title: "Package No.",
              name: "packageNo",
              noneditable: false,
              type: "text",
            },
            // { title: "Tare Weight", name: "tareKgs" },
            // { title: "Net Weight", name: "netKgs" },

            {
              title: "Sample Qty. (KGs)",
              name: "SampleQty",
              noneditable: false,
              type: "number",
            },
            {
              title: "Total Package",
              name: "totalPackages",
              noneditable: false,
              type: "number",
            },
            {
              title: "Quality Comments",
              name: "qualityComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Short Excess Weight",
              name: "shortExcessWeight",
              noneditable: true,
              type: "text",
            },

            // { title: "Auction Date", name: "auctionDate" },
            // { title: "Auction Date", name: "auctionDate" },
            // { title: "Tea Type", name: "teaTypeName" },
            // { title: "Category", name: "categoryName" },
            // { title: "Session Time", name: "sessionTime" },
            // { title: "Lot No.", name: "LotNo" },
            // { title: "Invoice No.", name: "invoiceNo" },
            // { title: "Origin", name: "Origin" },
            // { title: "Tea Type", name: "teaTypeName" },
            // { title: "Sub Type", name: "subTeaTypeName" },
            // { title: "Category", name: "categoryName" },
            // { title: "Grade", name: "gradeName" },
            // { title: "No. of Packages", name: "noOfPackages" },

            // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
            // { title: "GP No.", name: "gpNo",noneditable:false },
            // { title: "GP Date", name: "gpDate",noneditable:false },
            // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
            // {
            //   title: "Price Increment",
            //   name: "priceIncrement",
            //   noneditable: false,
            //   type: "number",
            // },
            // { title: "Market Type", name: "marketTypeName",noneditable:false },
            // { title: "Package Type", name: "packageType",noneditable:false },
            // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
            // {
            //   title: "Garden Certification",
            //   name: "gardenCertification",
            //   noneditable: false,
            //   type: "text",
            // },
            // {
            //   title: "Quality Certification",
            //   name: "qualityCertification",
            //   noneditable: false,
            //   type: "text",
            // },
            // {
            //   title: "Age of the Tea (In Months)",
            //   name: "ageOfProducts",
            //   noneditable: false,
            //   type: "number",
            // },
            // {
            //   title: "Color of Brew",
            //   name: "brewColor",
            //   noneditable: false,
            //   type: "text",
            // },
            // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
            // {
            //   title: "Brewers Comments",
            //   name: "brewersComments",
            //   noneditable: false,
            //   type: "text",
            // },
            // {
            //   title: "System Base Price",
            //   name: "SystemBasePrice",
            //   noneditable: true,
            //   type: "number",
            // },
            // { title: "LSP / SP", name: "LSP_SP", noneditable: true },
            // { title: "System Base Price", name: "SBP_LSP_SP" },
          ]
          : baseUrlEng === "EnglishAuctionKutchaCatalogue"
            ? [
              // { title: "Season", name: "season" },
              // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
              // { title: "Mark", name: "markName", noneditable: true, type: "text" },
              {
                title: "Lot No",
                name: "LotNo",
                noneditable: true,
                type: "text",
              },
              {
                title: "Mark",
                name: "markName",
                noneditable: true,
                type: "text",
              },
              {
                title: "Base Price",
                name: "basePrice",
                noneditable: false,
                type: "number",
              },
              {
                title: "Reserve Price",
                name: "reservePrice",
                noneditable: false,
                type: "number",
              },
              {
                title: "Auctioneer's Valuation",
                name: "auctioneerValuation",
                noneditable: false,
                type: "number",
              },

              {
                title: "Session Type",
                name: "sessionTypeName",
                noneditable: false,
                type: "select",
              },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Lot Comments",
                name: "lotComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Gross Weight",
                name: "grossKgs",
                noneditable: false,
                type: "number",
              },
              {
                title: "Tare Weight",
                name: "tareKgs",
                noneditable: false,
                type: "number",
              },
              {
                title: "Category",
                name: "categoryName",
                noneditable: true,
                type: "text",
              },
              {
                title: "Package No.",
                name: "packageNo",
                noneditable: false,
                type: "text",
              },
              // { title: "Tare Weight", name: "tareKgs" },
              // { title: "Net Weight", name: "netKgs" },

              {
                title: "Sample Qty. (KGs)",
                name: "SampleQty",
                noneditable: false,
                type: "number",
              },
              {
                title: "Total Package",
                name: "totalPackages",
                noneditable: false,
                type: "number",
              },
              {
                title: "Quality Comments",
                name: "qualityComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Short Excess Weight",
                name: "shortExcessWeight",
                noneditable: true,
                type: "text",
              },

              {
                title: "Remarks",
                name: "remarks",
                noneditable: false,
                type: "text",
              },
            ]
            : []
  );

  // if (getDataByPrems !== undefined && getDataByPrems !== null)
  //   console.log(getDataByPrems, "getDataByPrems");
  // const validationSchema =
  const validationSchema =
    userRole === "buyer"
      ? Yup.object({
        // myValuation: Yup.string().required("My Valuation is required"),
        // myComments: Yup.string().required("My Comments is required"),
      })
      : baseUrlEng === "AuctionCatalog"
        ? Yup.object({
          basePrice: Yup.number()
            .positive("Base price should be greater than zero")
            .typeError("Base Price must be a number")
            .required("Please enter Base Price")
            .test(
              "twoDecimalPlaces",
              "Base Price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          priceIncrement: Yup.number().required("Please enter Price Increment"),
          gardenCertification: Yup.string().required(
            "Please enter Garden Certification"
          ),
          ageOfProducts: Yup.number().required(
            "Please enter Age of the Tea (In Months)"
          ),
          auctioneerValuation: Yup.number()
            .typeError("Auctioneer's Valuation must be a number")
            .required("Please enter Auctioneer's Valuation")
            .test(
              "twoDecimalPlaces",
              "Auctioneer Valuation cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                // two dasimle value change in resever price auctioner valuaction and also baseprise if chnage in this
                // const decimalPart = value.toString().split(".")[1];
                // return !decimalPart || decimalPart.length <= 2;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          reservePrice: Yup.number()
            .typeError("Reserve Price must be a number")
            .test(
              "minBasePrice",
              "Reserve Price should always be greater than or equal to Base Price.",
              function (value) {
                const { basePrice } = this.parent;
                return basePrice === undefined || value >= basePrice;
              }
            )
            // .min(
            //   Yup.ref("basePrice"),
            //   "Reserve Price should always be greater than or equal to Base Price."
            // )
            .test(
              "twoDecimalPlaces",
              "Reserve price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .required("Please enter Reserve Price"),
          markPackageComments: Yup.string().max(
            255,
            "Mark & Packaging Comments must be 255 characters or less"
          ),
          lotComments: Yup.string().max(
            255,
            "Lot Comments must be 255 characters or less"
          ),
          grossKgs: Yup.number()
            .required("Please enter Gross Weight")
            .typeError("Gross Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Gross Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          tareKgs: Yup.number()
            .required("Tare Kgs is required")
            .typeError("Tare KGs must be a number")
            .positive("Tare KGs must be a positive number")
            .test(
              "is-numeric-with-decimal",
              "Positive Numeric with two digits after decimal point Non-zero.",
              function (value) {
                return /^\d+(\.\d{1,2})?$/.test(value);
              }
            )
            .min(0.01, "Tare Kgs must be at least 0.01")
            .lessThan(
              Yup.ref("grossKgs"),
              "Tare KGs must be less than Gross KGs"
            ),
          packageNo: Yup.string()
            .required("Package No is required")
            .test(
              "is-package-range",
              "Enter the appropriate package number.For example, 1-25, 10-50, 001-0030, etc.",
              function (value) {
                if (!/^\d+-\d+$/.test(value)) {
                  return false;
                }

                const [start, end] = value.split("-");
                return parseInt(start) <= parseInt(end);
              }
            ),
          totalPackages: Yup.string().required("Total Packages is required"),
          sampleQty: Yup.number()
            .typeError("Sample Qty. must be a number")
            .test(
              "twoDecimalPlaces",
              "Sample Qty must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          shortExcessWeight: Yup.number()
            .typeError("Short/Excess Weight must be a number")
            .test(
              "is-numeric-with-decimal",
              "Positive Numeric with two digits after decimal point Non-zero.",
              function (value = 0) {
                return /^\d+(\.\d{1,2})?$/.test(value || 0);
              }
            ),
          // Add validation for other fields here
        })
        : baseUrlEng === "EnglishAuctionCatalog"
          ? Yup.object({
            //sessionTypeName: Yup.string().required("Please select Session Type"),
            basePrice: Yup.number()
              .positive("Base price should be greater than zero")
              .typeError("Base Price must be a number")
              .required("Please enter Base Price")
              .test(
                "twoDecimalPlaces",
                "Base Price cannot have decimal value",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString();
                  return !decimalPart.includes(".");
                }
              )
              .test(
                "maxBasePrice",
                "Base Price should always be less than or equal to Reserve Price.",
                function (value) {
                  const { reservePrice } = this.parent;
                  return reservePrice === undefined || value <= reservePrice;
                }
              ),
            // .max(
            //   Yup.ref("reservePrice"),
            //   "Base Price should always be less than or equal to Reserve Price."
            // )
            auctioneerValuation: Yup.number()
              .typeError("Auctioneer's Valuation must be a number")
              .required("Please enter Auctioneer's Valuation")
              .test(
                "twoDecimalPlaces",
                "Auctioneer Valuation cannot have decimal value",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString();
                  return !decimalPart.includes(".");
                }
              )
              .test(
                "maxReservePricePrice",
                "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
                function (value) {
                  const { reservePrice } = this.parent;
                  return reservePrice === undefined || value >= reservePrice;
                }
              ),
            // .min(
            //   Yup.ref("reservePrice"),
            //   "Auctioneer's Valuation should always be greater than or equal to Reserve Price."
            // )
            reservePrice: Yup.number()
              .typeError("Reserve Price must be a number")
              .test(
                "minBasePrice",
                "Reserve Price should always be greater than or equal to Base Price.",
                function (value) {
                  const { basePrice } = this.parent;
                  return basePrice === undefined || value >= basePrice;
                }
              )
              // .min(
              //   Yup.ref("basePrice"),
              //   "Reserve Price should always be greater than or equal to Base Price."
              // )
              .test(
                "twoDecimalPlaces",
                "Reserve price cannot have decimal value",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString();
                  return !decimalPart.includes(".");
                }
              )
              .required("Please enter Reserve Price"),
            markPackageComments: Yup.string().max(
              255,
              "Mark & Packaging Comments must be 255 characters or less"
            ),
            lotComments: Yup.string().max(
              255,
              "Lot Comments must be 255 characters or less"
            ),
            // grossWeight: Yup.number()
            //   .typeError("Gross Weight must be a number")
            //   .test(
            //     "twoDecimalPlaces",
            //     "Gross Weight must have at most two decimal places",
            //     (value) => {
            //       if (typeof value !== "number") return true;
            //       const decimalPart = value.toString().split(".")[1];
            //       return !decimalPart || decimalPart.length <= 2;
            //     }
            //   ),
            grossKgs: Yup.number()
              .required("Please enter Gross Weight")
              .typeError("Gross Weight must be a number")
              .test(
                "twoDecimalPlaces",
                "Gross Weight must have at most two decimal places",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString().split(".")[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              ),
            tareKgs: Yup.number()
              .required("Please enter Tare Weight")
              .typeError("Tare Weight must be a number")
              .test(
                "twoDecimalPlaces",
                "Tare  Weight must have at most two decimal places",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString().split(".")[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              ),
            packageNo: Yup.string()
              .required("Please enter Packege No.")
              .matches(/^\d+-\d+$/, "Package No. must be in the format X-Y"),

            sampleQty: Yup.number()
              .typeError("Sample Qty. must be a number")
              .test(
                "twoDecimalPlaces",
                "Sample Qty must have at most two decimal places",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString().split(".")[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              ),
            markName: Yup.number()
              .typeError("Mark Name must be a number")
              .required("Please enter Mark Name"),
            // Add validation for other fields here
          })
          : baseUrlEng === "EnglishAuctionKutchaCatalogue"
            ? Yup.object({
              // sessionTypeName: Yup.string().required("Please select Session Type"),
              // basePrice: Yup.number()
              //   .positive("Base price should be greater than zero")
              //   .typeError("Base Price must be a number")
              //   .required("Please enter Base Price")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Base Price cannot have decimal value",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString();
              //       return !decimalPart.includes(".");
              //     }
              //   )
              //   .test(
              //     "maxBasePrice",
              //     "Base Price should always be less than or equal to Reserve Price.",
              //     function (value) {
              //       const { reservePrice } = this.parent;
              //       return reservePrice !== undefined || value <= reservePrice;
              //     }
              //   ),
              // auctioneerValuation: Yup.number()
              //   .typeError("Auctioneer's Valuation must be a number")
              //   .required("Please enter Auctioneer's Valuation")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Auctioneer Valuation cannot have decimal value",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString();
              //       return !decimalPart.includes(".");
              //     }
              //   )
              //   .test(
              //     "maxReservePricePrice",
              //     "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
              //     function (value) {
              //       const { reservePrice } = this.parent;
              //       return reservePrice === undefined || value >= reservePrice;
              //     }
              //   ),
              // reservePrice: Yup.number()
              //   .typeError("Reserve Price must be a number")
              //   .test(
              //     "minBasePrice",
              //     "Reserve Price should always be greater than or equal to Base Price.",
              //     function (value) {
              //       const { basePrice } = this.parent;
              //       return basePrice === undefined || value >= basePrice;
              //     }
              //   )
              //   .test(
              //     "twoDecimalPlaces",
              //     "Reserve price cannot have decimal value",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString();
              //       return !decimalPart.includes(".");
              //     }
              //   )
              //   .required("Please enter Reserve Price"),
              // markPackageComments: Yup.string().max(
              //   255,
              //   "Mark & Packaging Comments must be 255 characters or less"
              // ),
              // lotComments: Yup.string().max(
              //   255,
              //   "Lot Comments must be 255 characters or less"
              // ),
              // grossKgs: Yup.number()
              //   .required("Please enter Gross Weight")
              //   .typeError("Gross Weight must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Gross Weight must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              // tareKgs: Yup.number()
              //   .typeError("Tare  Weight must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Tare Weight must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              // packageNo: Yup.string().matches(
              //   /^\d+-\d+$/,
              //   "Package No. must be in the format X-Y"
              // ),

              // sampleQty: Yup.number()
              //   .typeError("Sample Qty. must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Sample Qty must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              // Add validation for other fields here
              sessionTypeName: Yup.string().required("Please select Session Type"),
              basePrice: Yup.number()
                .nullable()
                .typeError("Base Price must be a number")
                // .positive("Base price should be greater than zero")
                .test(
                  "twoDecimalPlaces",
                  "Base Price cannot have decimal value",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    return !value.toString().includes(".");
                  }
                )
                .test(
                  "maxBasePrice",
                  "Base Price should always be less than or equal to Reserve Price.",
                  function (value) {
                    const { reservePrice } = this.parent;
                    return reservePrice === undefined || value <= reservePrice;
                  }
                ),
              auctioneerValuation: Yup.number()
                .nullable()
                .typeError("Auctioneer's Valuation must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Auctioneer Valuation cannot have decimal value",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    return !value.toString().includes(".");
                  }
                )
                .test(
                  "maxReservePricePrice",
                  "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
                  function (value) {
                    const { reservePrice } = this.parent;
                    return reservePrice === undefined || value >= reservePrice;
                  }
                ),
              reservePrice: Yup.number()
                .nullable()
                .typeError("Reserve Price must be a number")
                .test(
                  "minBasePrice",
                  "Reserve Price should always be greater than or equal to Base Price.",
                  function (value) {
                    const { basePrice } = this.parent;
                    return basePrice === undefined || value >= basePrice;
                  }
                )
                .test(
                  "twoDecimalPlaces",
                  "Reserve price cannot have decimal value",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    return !value.toString().includes(".");
                  }
                ),
              markPackageComments: Yup.string().max(
                255,
                "Mark & Packaging Comments must be 255 characters or less"
              ),
              lotComments: Yup.string().max(
                255,
                "Lot Comments must be 255 characters or less"
              ),
              grossKgs: Yup.number()
                .nullable()
                .typeError("Gross Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Gross Weight must have at most two decimal places",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    const decimalPart = value?.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              tareKgs: Yup.number()
                .nullable()
                .typeError("Tare Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Tare Weight must have at most two decimal places",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    const decimalPart = value?.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              packageNo: Yup.string()
                .required("Package No. must be in the format X-Y") // Ensures the field is mandatory
                .matches(/^\d+-\d+$/, "Package No. must be in the format X-Y"),
              sampleQty: Yup.number()
                .nullable()
                .typeError("Sample Qty. must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Sample Qty must have at most two decimal places",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    const decimalPart = value?.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
            })
            : Yup.object({
              sessionTypeName: Yup.string().required("Please select Session Type"),
              basePrice: Yup.number()
                .positive("Base price should be greater than zero")
                .typeError("Base Price must be a number")
                .required("Please enter Base Price")
                .test(
                  "twoDecimalPlaces",
                  "Base Price cannot have decimal value",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString();
                    return !decimalPart.includes(".");
                  }
                )
                .max(
                  Yup.ref("reservePrice"),
                  "Base Price should always be less than or equal to Reserve Price."
                ),
              auctioneerValuation: Yup.number()
                .typeError("Auctioneer's Valuation must be a number")
                .required("Please enter Auctioneer's Valuation")
                .test(
                  "twoDecimalPlaces",
                  "Auctioneer Valuation cannot have decimal value",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString();
                    return !decimalPart.includes(".");
                  }
                ),
              reservePrice: Yup.number()
                .typeError("Reserve Price must be a number")
                .min(
                  Yup.ref("basePrice"),
                  "Reserve Price should always be greater than or equal to Base Price."
                )
                .test(
                  "twoDecimalPlaces",
                  "Reserve price cannot have decimal value",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString();
                    return !decimalPart.includes(".");
                  }
                )
                .required("Please enter Reserve Price"),
              markPackageComments: Yup.string().max(
                255,
                "Mark & Packaging Comments must be 255 characters or less"
              ),
              lotComments: Yup.string().max(
                255,
                "Lot Comments must be 255 characters or less"
              ),
              // grossWeight: Yup.number()
              //   .typeError("Gross Weight must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Gross Weight must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              grossKgs: Yup.number()
                .required("Please enter Gross Weight")
                .typeError("Gross Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Gross Weight must have at most two decimal places",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              tareKgs: Yup.number()
                .typeError("Tare Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Tare  Weight must have at most two decimal places",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              packageNo: Yup.string().matches(
                /^\d+-\d+$/,
                "Package No. must be in the format X-Y"
              ),

              sampleQty: Yup.number()
                .typeError("Sample Qty. must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Sample Qty must have at most two decimal places",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              // Add validation for other fields here
            });

  // useEffect(() => {
  //   setMyCatalogForAuctioneer(auctionCatalogDetail);
  // }, [auctionCatalogDetail.saleNo]);
  const formik = useFormik({
    initialValues: {
      saleNo: "",
      markName: "",
      basePrice: "",
      auctioneerValuation: "",
      reservePrice: "",
      markPackageComments: "",
      lotComments: "",
      grossKgs: "",
      packageNo: "",
      SampleQty: "",
      qualityComments: "",
      priceIncrement: 1,
      gardenCertification: "",
      qualityCertification: "",
      brewColor: "",
      ageOfProducts: "",
      brewersComments: "",
      SystemBasePrice: "",
      SBP_LSP_SP: "",
      shortExcessWeight: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      openLoader();
      // Handle form submission, e.g., send data to the server
      // console.log("Form submitted with values:", values);
      // if (getDataByPrems?.at(0).hours_date_difference < 48) {
      // if ((values.myValuation === "" || values.myValuation === null || values.myValuation === undefined)
      //   && (values.groupCode == "-" || values.groupCode === "" || values.groupCode === null || values.groupCode === undefined)
      //   && (values.myComments === "" || values.myComments === null || values.myComments === undefined)) {
      //   CustomToast.error("Please fill atleast one field (My valuation,Group Code,My Comments) among these !");
      //   return false;
      // }
      if (userRole === "buyer") {
        axiosMain
          .post(
            `/preauction/${baseUrlEng}/AddValuation?role=` +
            userRole +
            "&validateAction=submit&dataFlag=Menual&season=" +
            auctionCatalogDetail.season +
            "&saleNo=" +
            auctionCatalogDetail.saleNo,
            // axios
            //   .post(
            //     "http://192.168.101.221:5080/preauction/AuctionCatalog/UploadValuation?role=" +
            //       userRole,
            // [{
            //   auctionCatalogId: auctionCatalogId,
            //   season: getDataByPrems[0]?.season,
            //   saleNo:
            //     getDataByPrems[0]?.saleNo !== "" ||
            //     getDataByPrems[0]?.saleNo !== 0
            //       ? parseInt(getDataByPrems[0]?.saleNo)
            //       : 0,
            //   SampleQty: SampleQty,
            //   basePrice: basePrice,
            //   reservePrice: reservePrice,
            //   auctioneerValuation: auctioneerValuation,
            //   priceIncrement: priceIncrement,
            //   markPackageComments: markPackageComments,
            //   lotComments: lotComments,
            //   qualityComments: qualityComments,
            //   qualityCertification: qualityCertification,
            //   brewColor: brewColor,
            //   ageOfProducts: ageOfProducts,
            //   brewersComments: brewersComments,
            //   gardenCertification: gardenCertification,
            //   netWeight: netWeight,
            //   auctioneerId: userId, //auctioner
            // }]
            [
              {
                //...values,
                myValuation: values.myValuation === "" ? 0 : values.myValuation,
                groupCode:
                  values.groupCode == "-" || values.groupCode === ""
                    ? null
                    : values.groupCode,
                auctionCenterId,
                updatedBy: userId,
                createdBy: userId,

                lotNo: values.lotNo,
                myComments: values.myComments,
              },
            ]
          )
          .then((res) => {
            if (res.data.statusCode === 204) {
              CustomToast.warning(res.data.message);
            } else if (res.data.statusCode === 200) {
              CustomToast.success(res.data.message);
              setOpenUploadUpdateValuation(false);
              resetgetmycatalog();
              resetForm();
            } else {
              CustomToast.error(res.data.message);
            }
            closeLoader();
          })
          .catch((error) => {
            // CustomToast.error();
            closeLoader();
          });
      } else {
        if (
          (baseUrlEng === "AuctionCatalog" &&
            getDataByPrems?.at(0)?.minute_difference >= 15 &&
            getDataByPrems?.at(0)?.hours_date_difference < 48) ||
          (baseUrlEng === "EnglishAuctionCatalog" &&
            // getDataByPrems?.at(0)?.minute_difference >= 15 &&
            getDataByPrems?.at(0)?.hours_date_difference < 24) ||
          (baseUrlEng === "EnglishAuctionKutchaCatalogue" &&
            // getDataByPrems?.at(0)?.minute_difference >= 15 &&
            getDataByPrems?.at(0)?.hours_date_difference < 24)
        ) {
          const {
            auctionCatalogId,
            SampleQty,
            basePrice,
            reservePrice,
            auctioneerValuation,
            priceIncrement,
            markPackageComments,
            lotComments,
            qualityComments,
            qualityCertification,
            brewColor,
            ageOfProducts,
            brewersComments,
            gardenCertification,
            netWeight,
            auctioneerId,
            saleNo,
            season,
            grossKgs,
            tareKgs,
          } = values;

          debugger;
          axiosMain
            .post(
              baseUrlEng === "EnglishAuctionKutchaCatalogue"
                ? `/preauction/EnglishAuctionKutchaCatalogue/UpdateKutchaCatalogValuationReservePrice`
                : `/preauction/${baseUrlEng}/UpdateMyCatalogValuationReservePrice?role=` +
                userRole,
              baseUrlEng === "AuctionCatalog" ||
                baseUrlEng === "EnglishAuctionKutchaCatalogue"
                ? {
                  season: auctionCatalogDetail?.season?.toString(),
                  saleNo: parseInt(auctionCatalogDetail?.saleNo),
                  auctionCenterId,
                  KutchaCatalogId: parseInt(
                    getDataByPrems?.at(0)?.KutchaCatalogId
                  ),
                  reservePrice,
                  basePrice,
                  auctioneerId: userId,
                  ageOfProducts: values.ageOfProducts,
                  gardenCertification: values.gardenCertification,
                  SaleProgramId: getDataByPrems[0]?.saleprogramid,
                }
                : {
                  season: auctionCatalogDetail?.season,
                  saleNo: parseInt(auctionCatalogDetail?.saleNo),
                  auctionCenterId,
                  KutchaCatalogId: parseInt(
                    getDataByPrems?.at(0)?.KutchaCatalogId
                  ),
                  reservePrice,
                  auctioneerId: userId,
                  ageOfProducts: values.ageOfProducts,
                  gardenCertification: values.gardenCertification,
                  SaleProgramId: getDataByPrems[0]?.saleprogramid,
                  auctionCatalogId: getDataByPrems[0]?.auctionCatalogId,
                }
            )
            .then((res) => {
              if (res.data.statusCode === 403) {
                CustomToast.warning(res.data.message);
              } else if (res.data.statusCode === 200) {
                CustomToast.success(res.data.message);
                setOpenUploadUpdateValuation(false);
                resetForm();
                if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
                  resetgetkuchacatalog();
                } else {
                  resetgetmycatalog();
                }
              } else {
                CustomToast.error(res.data.message);
              }
              closeLoader();
            })
            .catch((error) => {
              // CustomToast.error();
              closeLoader();
            });
        } else {
          values.auctioneerId = getDataByPrems?.at(0)?.auctioneerId;
          const {
            auctionCatalogId,
            SampleQty,
            basePrice,
            reservePrice,
            auctioneerValuation,
            priceIncrement,
            markPackageComments,
            lotComments,
            qualityComments,
            qualityCertification,
            brewColor,
            ageOfProducts,
            brewersComments,
            gardenCertification,
            netWeight,
            auctioneerId,
            grossKgs,
            tareKgs,
            totalPackages,
            packageNo,
            sessionTypeName,
            remarks,
            shortExcessWeight,
            markName,
          } = values;
          axiosMain
            .post(
              baseUrlEng === "EnglishAuctionKutchaCatalogue"
                ? `/preauction/${baseUrlEng}/UpdateKutchaCatalogueDetails?role=` +
                userRole +
                "&flag=" +
                dataFlag +
                "&validateAction=submit&season=" +
                auctionCatalogDetail.season +
                "&saleNo=" +
                auctionCatalogDetail.saleNo
                : `/preauction/${baseUrlEng}/UploadValuation?role=` +
                userRole +
                "&flag=" +
                dataFlag +
                "&validateAction=submit&season=" +
                auctionCatalogDetail.season +
                "&saleNo=" +
                auctionCatalogDetail.saleNo,
              // axios
              //   .post(
              //     "http://192.168.101.221:5080/preauction/AuctionCatalog/UploadValuation?role=" +
              //       userRole,
              // [{
              //   auctionCatalogId: auctionCatalogId,
              //   season: getDataByPrems[0]?.season,
              //   saleNo:
              //     getDataByPrems[0]?.saleNo !== "" ||
              //     getDataByPrems[0]?.saleNo !== 0
              //       ? parseInt(getDataByPrems[0]?.saleNo)
              //       : 0,
              //   SampleQty: SampleQty,
              //   basePrice: basePrice,
              //   reservePrice: reservePrice,
              //   auctioneerValuation: auctioneerValuation,
              //   priceIncrement: priceIncrement,
              //   markPackageComments: markPackageComments,
              //   lotComments: lotComments,
              //   qualityComments: qualityComments,
              //   qualityCertification: qualityCertification,
              //   brewColor: brewColor,
              //   ageOfProducts: ageOfProducts,
              //   brewersComments: brewersComments,
              //   gardenCertification: gardenCertification,
              //   netWeight: netWeight,
              //   auctioneerId: userId, //auctioner
              // }][
              baseUrlEng === "EnglishAuctionKutchaCatalogue"
                ? [
                  {
                    KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                    invoiceId: getDataByPrems?.at(0)?.invoiceId,
                    saleNo: getDataByPrems?.at(0)?.saleNo,
                    locationInsideWarehouse:
                      getDataByPrems?.at(0)?.locationInsideWarehouse,
                    remarks: remarks, //getDataByPrems?.at(0)?.remarks,

                    // ageOfProducts:
                    //   ageOfProducts === undefined ? null : ageOfProducts,
                    auctioneerValuation:
                      auctioneerValuation === undefined
                        ? null
                        : auctioneerValuation,
                    basePrice: basePrice === undefined ? null : basePrice,
                    // brewersComments:
                    //   brewersComments === undefined ? null : brewersComments,
                    // brewColor: brewColor === undefined ? null : brewColor,
                    // gardenCertification:
                    //   gardenCertification === undefined
                    //     ? null
                    //     : gardenCertification,
                    lotComments:
                      lotComments === undefined ? null : lotComments,
                    LotNo: getDataByPrems?.at(0)?.LotNo,
                    markPackageComments:
                      markPackageComments === undefined
                        ? null
                        : markPackageComments,
                    priceIncrement:
                      priceIncrement === undefined ||
                        priceIncrement === "" ||
                        priceIncrement === null
                        ? 1
                        : priceIncrement,
                    // // qualityCertification:
                    // //   qualityCertification === undefined
                    // //     ? null
                    // //     : qualityCertification,
                    qualityComments:
                      qualityComments === undefined ? null : qualityComments,
                    reservePrice: parseFloat(reservePrice),
                    SampleQty: SampleQty,
                    sessionTypeName: sessionTypeName,
                    // createdOn: null,
                    createdBy: userId, //auctioner
                    updatedBy: userId, //auctioner
                    // updatedOn: null,
                    status: 1,
                    auctionCenterId: auctionCenterId,
                    saleprogramid: saleProgramId?.at(0)?.SaleProgramId,

                    auctioneerId: userId,
                    auctionTypeMasterId: 2,
                    // markPackageComments,
                    // lotComments,
                    grossKgs,
                    tareKgs,
                    //new added
                    packageNo: values.packageNo, // getDataByPrems?.at(0)?.packageNo,
                    totalPackages: values.totalPackages, // getDataByPrems?.at(0)?.totalPackages,
                  },
                ]
                : baseUrlEng === "AuctionCatalog"
                  ? [
                    {
                      KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                      invoiceId: getDataByPrems?.at(0)?.invoiceId,
                      ageOfProducts:
                        ageOfProducts === undefined ? null : ageOfProducts,
                      auctioneerValuation:
                        auctioneerValuation === undefined
                          ? null
                          : auctioneerValuation,
                      basePrice: basePrice === undefined ? null : basePrice,
                      brewersComments:
                        brewersComments === undefined ? null : brewersComments,
                      brewColor: brewColor === undefined ? null : brewColor,
                      gardenCertification:
                        gardenCertification === undefined
                          ? null
                          : gardenCertification,
                      lotComments:
                        lotComments === undefined ? null : lotComments,
                      LotNo: getDataByPrems?.at(0)?.LotNo,
                      markPackageComments:
                        markPackageComments === undefined
                          ? null
                          : markPackageComments,
                      priceIncrement:
                        priceIncrement === undefined ? null : priceIncrement,
                      qualityCertification:
                        qualityCertification === undefined
                          ? null
                          : qualityCertification,
                      qualityComments:
                        qualityComments === undefined ? null : qualityComments,
                      reservePrice: parseFloat(reservePrice),
                      SampleQty: SampleQty,
                      sessionType: getDataByPrems?.at(0)?.sessionType,
                      createdOn: null,
                      createdBy: userId, //auctioner
                      updatedBy: userId, //auctioner
                      updatedOn: null,
                      status: 1,
                      auctionCenterId: auctionCenterId,
                      saleprogramid: getDataByPrems?.at(0)?.saleprogramid,
                      grossKgs,
                      tareKgs,
                      totalPackages: values.totalPackages,
                      packageNo: values.packageNo,
                      shortExcessWeight: shortExcessWeight || 0,
                    },
                  ]
                  : [
                    {
                      sessionType: getDataByPrems?.at(0)?.sessionType,
                      KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                      invoiceId: getDataByPrems?.at(0)?.invoiceId,
                      saleNo: getDataByPrems?.at(0)?.saleNo,
                      locationInsideWarehouse:
                        getDataByPrems?.at(0)?.locationInsideWarehouse,
                      remarks: getDataByPrems?.at(0)?.remarks,
                      // ageOfProducts:
                      //   ageOfProducts === undefined ? null : ageOfProducts,
                      auctioneerValuation:
                        auctioneerValuation === undefined
                          ? null
                          : auctioneerValuation,
                      basePrice: basePrice === undefined ? null : basePrice,
                      // brewersComments:
                      //   brewersComments === undefined ? null : brewersComments,
                      // brewColor: brewColor === undefined ? null : brewColor,
                      // gardenCertification:
                      //   gardenCertification === undefined
                      //     ? null
                      //     : gardenCertification,
                      lotComments:
                        lotComments === undefined ? null : lotComments,
                      LotNo: getDataByPrems?.at(0)?.LotNo,
                      markPackageComments:
                        markPackageComments === undefined
                          ? null
                          : markPackageComments,
                      priceIncrement:
                        priceIncrement === undefined ? null : priceIncrement,
                      // // qualityCertification:
                      // //   qualityCertification === undefined
                      // //     ? null
                      // //     : qualityCertification,
                      qualityComments:
                        qualityComments === undefined ? null : qualityComments,
                      reservePrice: parseFloat(reservePrice),
                      SampleQty: SampleQty,
                      // sessionTypeName: getDataByPrems?.at(0)?.sessionType,
                      createdOn: null,
                      createdBy: userId, //auctioner
                      updatedBy: userId, //auctioner
                      updatedOn: null,
                      status: 1,
                      auctionCenterId: auctionCenterId,
                      saleprogramid: getDataByPrems?.at(0)?.saleprogramid,

                      auctioneerId: userId,
                      auctionTypeMasterId: 2,
                      // markPackageComments,
                      // lotComments,
                      grossKgs,
                      tareKgs,
                      //new added
                      // packageNo: getDataByPrems?.at(0)?.packageNo,
                      // totalPackages: getDataByPrems?.at(0)?.totalPackages,
                      packageNo: values.packageNo, // getDataByPrems?.at(0)?.packageNo,
                      totalPackages: values.totalPackages, // getDataByPrems?.at(0)?.totalPackages,
                      markId: parseInt(values?.markName),
                    },
                  ]
            )
            .then((res) => {
              if (res.data.statusCode === 204) {
                CustomToast.warning(res.data.message);
              } else if (
                res.data.statusCode === 422 &&
                (baseUrlEng === "EnglishAuctionCatalog" ||
                  baseUrlEng === "EnglishAuctionKutchaCatalogue")
              ) {
                // CustomToast.warning(response.data.message);
                setDataFlag(true);
                setOpenModalConformation(true);
                setOpenModalConformationTitle(res.data.message);
              } else if (res.data.statusCode === 200) {
                setOpenModalConformation(false);
                setDataFlag(false);
                CustomToast.success(res.data.message);
                setOpenUploadUpdateValuation(false);
                resetForm();
                if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
                  resetgetkuchacatalog();
                } else {
                  resetgetmycatalog();
                }
              } else if (res.data.statusCode === 403) {
                CustomToast.warning(res.data.message);
              } else {
                CustomToast.error(res.data.message);
              }
              closeLoader();
            })
            .catch((error) => {
              // CustomToast.error();
              closeLoader();
            });
        }
      }
      // }

      // else {
      //   const {
      //     auctionCatalogId,
      //     SampleQty,
      //     basePrice,
      //     reservePrice,
      //     auctioneerValuation,
      //     priceIncrement,
      //     markPackageComments,
      //     lotComments,
      //     qualityComments,
      //     qualityCertification,
      //     brewColor,
      //     ageOfProducts,
      //     brewersComments,
      //     gardenCertification,
      //     netWeight,
      //   } = values;
      //   // axiosMain
      //   //   .post("/preauction/AuctionCatalog/UpdateMyCatalogValuationDetails", {
      //   axios
      //     .post(
      //       "http://192.168.101.221:5080/preauction/AuctionCatalog/UploadValuation?role=" +
      //         userRole,
      //       [
      //         {
      //           auctionCatalogId: auctionCatalogId,
      //           season: getDataByPrems?.at(0)?.season,
      //           saleNo: getDataByPrems?.at(0)?.saleNo,
      //           SampleQty: SampleQty,
      //           basePrice: basePrice,
      //           reservePrice: reservePrice,
      //           auctioneerValuation: auctioneerValuation,
      //           priceIncrement: priceIncrement,
      //           markPackageComments: markPackageComments,
      //           lotComments: lotComments,
      //           qualityComments: qualityComments,
      //           qualityCertification: qualityCertification,
      //           brewColor: brewColor,
      //           ageOfProducts: ageOfProducts,
      //           brewersComments: brewersComments,
      //           gardenCertification: gardenCertification,
      //           netWeight: netWeight,
      //           auctionCenterId: auctionCenterId,
      //           // auctioneerId: getDataByPrems?.at(0)?.auctioneerId,
      //           auctioneerId: userId,
      //         },
      //       ]
      //     )
      //     .then((res) => {
      //       if (res.data.statusCode === 204) {
      //         CustomToast.warning(res.data.message);
      //       } else if (res.data.statusCode === 200) {
      //         CustomToast.success(res.data.message);
      //       } else {
      //         CustomToast.error(res.data.message);
      //       }
      //     })
      //     .catch((error) => {
      //       CustomToast.error();
      //     });
      // }
      // resetForm();
    },
  });

  useEffect(() => {
    if (baseUrlEng === "AuctionCatalog") {
      const firstValue = parseInt(formik.values.packageNo?.split("-")[0]);
      const secondValue = parseInt(formik.values.packageNo?.split("-")[1]);
      let result = firstValue - secondValue;
      if (firstValue > secondValue) {
        result = firstValue - secondValue;
      } else {
        result = secondValue - firstValue;
      }
      formik.setFieldValue("totalPackages", result + 1);
    }

    // console.log(, "formik.values");
  }, [formik.values.packageNo]);

  // useEffect(() => {
  //   if (getDataByPrems === undefined && getDataByPrems === null) {
  //     if (baseUrlEng === "EnglishAuctionCatalog" ||
  //       baseUrlEng === "EnglishAuctionKutchaCatalogue") {
  //       const firstValue = parseInt(formik.values.packageNo?.split("-")[0]);
  //       const secondValue = parseInt(formik.values.packageNo?.split("-")[1]);
  //       let result = firstValue - secondValue;
  //       if (firstValue > secondValue) {
  //         result = firstValue - secondValue;
  //       } else {
  //         result = secondValue - firstValue;
  //       }
  //       formik.setFieldValue("totalPackages", result + 1);
  //     }
  //   }

  //   // console.log(, "formik.values");
  // }, [formik.values.packageNo]);

  const fnpackegechange = (event) => {
    if (
      baseUrlEng === "EnglishAuctionCatalog" ||
      baseUrlEng === "EnglishAuctionKutchaCatalogue"
    ) {
      const firstValue = parseInt(event.target.value?.split("-")[0]);
      const secondValue = parseInt(event.target.value?.split("-")[1]);
      let result = firstValue - secondValue;
      if (firstValue > secondValue) {
        result = firstValue - secondValue;
      } else {
        result = secondValue - firstValue;
      }
      formik.setFieldValue("totalPackages", result + 1);
    }
  };
  useEffect(() => {
    setMyCatalogForAuctioneer(
      userRole === "buyer"
        ? [
          // { title: "Season", name: "season" },
          // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
          // { title: "Mark", name: "markName", noneditable: true, type: "text" },
          {
            title: "Lot No",
            name: "lotNo",
            noneditable: true,
            type: "text",
          },
          {
            title: "Mark",
            name: "markName",
            noneditable: true,
            type: "text",
          },
          {
            title: "Grade",
            name: "gradeName",
            noneditable: true,
            type: "text",
          },
          {
            title: "My Valuation",
            name: "myValuation",
            noneditable: false,
            type: "number",
          },
          {
            title: "My Comments",
            name: "myComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Group Code",
            name: "groupCode",
            noneditable: true,
            type: "select",
          },
        ]
        : baseUrlEng === "AuctionCatalog"
          ? [
            // { title: "Season", name: "season" },
            // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
            { title: "Mark", name: "Mark", noneditable: true, type: "text" },
            {
              title: "Lot No",
              name: "LotNo",
              noneditable: true,
              type: "text",
            },
            {
              title: "Base Price *",
              name: "basePrice",
              noneditable: false,
              type: "number",
            },
            {
              title: "Reserve Price *",
              name: "reservePrice",
              noneditable: false,
              type: "number",
            },
            {
              title: "Auctioneer's Valuation *",
              name: "auctioneerValuation",
              noneditable: false,
              type: "number",
            },

            // { title: "Auction Date", name: "auctionDate" },
            // { title: "Auction Date", name: "auctionDate" },
            // { title: "Tea Type", name: "teaTypeName" },
            // { title: "Category", name: "categoryName" },
            // { title: "Session Time", name: "sessionTime" },
            // { title: "Lot No.", name: "LotNo" },
            // { title: "Invoice No.", name: "invoiceNo" },
            // { title: "Origin", name: "Origin" },
            // { title: "Tea Type", name: "teaTypeName" },
            // { title: "Sub Type", name: "subTeaTypeName" },
            // { title: "Category", name: "categoryName" },
            // { title: "Grade", name: "gradeName" },
            // { title: "No. of Packages", name: "noOfPackages" },
            {
              title: "Mark & Packaging Comments",
              name: "markPackageComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Lot Comments *",
              name: "lotComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Gross Weight *",
              name: "grossKgs",
              noneditable: false,
              type: "number",
            },
            {
              title: "Tare Weight *",
              name: "tareKgs",
              noneditable: false,
              type: "number",
            },
            {
              title: "Package No. *",
              name: "packageNo",
              noneditable: false,
              type: "text",
            },
            {
              title: "Total Packages *",
              name: "totalPackages",
              noneditable: false,
              type: "number",
            },
            // { title: "Net Weight", name: "netKgs" },
            {
              title: "Sample Qty. (KGs)",
              name: "SampleQty",
              noneditable: false,
              type: "number",
            },
            {
              title: "Quality Comments",
              name: "qualityComments",
              noneditable: false,
              type: "text",
            },
            // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
            // { title: "GP No.", name: "gpNo",noneditable:false },
            // { title: "GP Date", name: "gpDate",noneditable:false },
            // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
            {
              title: "Package No.",
              name: "packageNo",
              noneditable: false,
              type: "text",
            },
            {
              title: "Total Packages",
              name: "totalPackages",
              noneditable: false,
              type: "number",
            },
            // { title: "Market Type", name: "marketTypeName",noneditable:false },
            // { title: "Package Type", name: "packageType",noneditable:false },
            // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
            {
              title: "Garden Certification *",
              name: "gardenCertification",
              noneditable: false,
              type: "text",
            },
            {
              title: "Quality Certification",
              name: "qualityCertification",
              noneditable: false,
              type: "text",
            },
            {
              title: "Age of the Tea (In Months) *",
              name: "ageOfProducts",
              noneditable: false,
              type: "number",
            },
            {
              title: "Color of Brew",
              name: "brewColor",
              noneditable: false,
              type: "text",
            },
            // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
            {
              title: "Brewers Comments",
              name: "brewersComments",
              noneditable: false,
              type: "text",
            },
            // {
            //   title: "System Base Price",
            //   name: "SystemBasePrice",
            //   noneditable: true,
            //   type: "number",
            // },
            { title: "LSP / SP", name: "LSP_SP", noneditable: true },
            { title: "System Base Price", name: "SBP", noneditable: true },
            {
              title: "Short Excess Weight",
              name: "shortExcessWeight",
              noneditable: false,
              type: "text",
            },
          ]
          : baseUrlEng === "EnglishAuctionCatalog"
            ? // baseUrlEng === "EnglishAuctionKutchaCatalogue"
            [
              // { title: "Season", name: "season" },
              // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
              // { title: "Mark", name: "markName", noneditable: true, type: "text" },
              {
                title: "Lot No",
                name: "LotNo",
                noneditable: true,
                type: "text",
              },
              {
                title: "Mark",
                name: "markName",
                noneditable: false,
                type: "select",
              },
              {
                title: "Base Price",
                name: "basePrice",
                noneditable: false,
                type: "number",
              },
              {
                title: "Reserve Price",
                name: "reservePrice",
                noneditable: false,
                type: "number",
              },
              {
                title: "Auctioneer's Valuation",
                name: "auctioneerValuation",
                noneditable: false,
                type: "number",
              },

              {
                title: "Session Type",
                name: "sessionTypeName",
                noneditable: true,
                type: "select",
              },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Lot Comments",
                name: "lotComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Gross Weight",
                name: "grossKgs",
                noneditable: false,
                type: "number",
              },
              {
                title: "Tare Weight",
                name: "tareKgs",
                noneditable: false,
                type: "number",
              },
              {
                title: "Category",
                name: "categoryName",
                noneditable: true,
                type: "text",
              },
              {
                title: "Package No.",
                name: "packageNo",
                noneditable: false,
                type: "text",
              },
              // { title: "Tare Weight", name: "tareKgs" },
              // { title: "Net Weight", name: "netKgs" },

              {
                title: "Sample Qty. (KGs)",
                name: "SampleQty",
                noneditable: false,
                type: "number",
              },
              {
                title: "Total Package",
                name: "totalPackages",
                noneditable: false,
                type: "number",
              },
              {
                title: "Quality Comments",
                name: "qualityComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Short Excess Weight",
                name: "shortExcessWeight",
                noneditable: false,
                type: "text",
              },

              // { title: "Auction Date", name: "auctionDate" },
              // { title: "Auction Date", name: "auctionDate" },
              // { title: "Tea Type", name: "teaTypeName" },
              // { title: "Category", name: "categoryName" },
              // { title: "Session Time", name: "sessionTime" },
              // { title: "Lot No.", name: "LotNo" },
              // { title: "Invoice No.", name: "invoiceNo" },
              // { title: "Origin", name: "Origin" },
              // { title: "Tea Type", name: "teaTypeName" },
              // { title: "Sub Type", name: "subTeaTypeName" },
              // { title: "Category", name: "categoryName" },
              // { title: "Grade", name: "gradeName" },
              // { title: "No. of Packages", name: "noOfPackages" },

              // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
              // { title: "GP No.", name: "gpNo",noneditable:false },
              // { title: "GP Date", name: "gpDate",noneditable:false },
              // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
              // {
              //   title: "Price Increment",
              //   name: "priceIncrement",
              //   noneditable: false,
              //   type: "number",
              // },
              // { title: "Market Type", name: "marketTypeName",noneditable:false },
              // { title: "Package Type", name: "packageType",noneditable:false },
              // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
              // {
              //   title: "Garden Certification",
              //   name: "gardenCertification",
              //   noneditable: false,
              //   type: "text",
              // },
              // {
              //   title: "Quality Certification",
              //   name: "qualityCertification",
              //   noneditable: false,
              //   type: "text",
              // },
              // {
              //   title: "Age of the Tea (In Months)",
              //   name: "ageOfProducts",
              //   noneditable: false,
              //   type: "number",
              // },
              // {
              //   title: "Color of Brew",
              //   name: "brewColor",
              //   noneditable: false,
              //   type: "text",
              // },
              // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
              // {
              //   title: "Brewers Comments",
              //   name: "brewersComments",
              //   noneditable: false,
              //   type: "text",
              // },
              // {
              //   title: "System Base Price",
              //   name: "SystemBasePrice",
              //   noneditable: true,
              //   type: "number",
              // },
              // { title: "LSP / SP", name: "LSP_SP", noneditable: true },
              // { title: "System Base Price", name: "SBP_LSP_SP" },
            ]
            : baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? [
                // { title: "Season", name: "season" },
                // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
                // { title: "Mark", name: "markName", noneditable: true, type: "text" },
                {
                  title: "Lot No",
                  name: "LotNo",
                  noneditable: true,
                  type: "text",
                },
                {
                  title: "Mark",
                  name: "markName",
                  noneditable: true,
                  type: "text",
                },
                {
                  title: "Base Price",
                  name: "basePrice",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Reserve Price",
                  name: "reservePrice",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Auctioneer's Valuation",
                  name: "auctioneerValuation",
                  noneditable: false,
                  type: "number",
                },

                {
                  title: "Session Type",
                  name: "sessionTypeName",
                  noneditable: true,
                  type: "select",
                },
                {
                  title: "Mark & Packaging Comments",
                  name: "markPackageComments",
                  noneditable: false,
                  type: "text",
                },
                {
                  title: "Lot Comments",
                  name: "lotComments",
                  noneditable: false,
                  type: "text",
                },
                {
                  title: "Gross Weight",
                  name: "grossKgs",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Tare Weight",
                  name: "tareKgs",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Category",
                  name: "categoryName",
                  noneditable: true,
                  type: "text",
                },
                {
                  title: "Package No.",
                  name: "packageNo",
                  noneditable: false,
                  type: "text",
                },
                // { title: "Tare Weight", name: "tareKgs" },
                // { title: "Net Weight", name: "netKgs" },

                {
                  title: "Sample Qty. (KGs)",
                  name: "SampleQty",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Total Package",
                  name: "totalPackages",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Quality Comments",
                  name: "qualityComments",
                  noneditable: false,
                  type: "text",
                },
                {
                  title: "Short Excess Weight",
                  name: "shortExcessWeight",
                  noneditable: false,
                  type: "text",
                },

                {
                  title: "Remarks",
                  name: "remarks",
                  noneditable: false,
                  type: "text",
                },
              ]
              : []
    );
  }, [baseUrlEng]);
  useEffect(() => {
    axiosMain
      .post(
        "/preauction/Common/BindGroupMasterByBuyerUserId?buyerUserId=" + userId,
        {}
      )
      .then((res) => {
        if (res.data.message) {
          setGroupCode(res.data.responseData);
        } else {
          setGroupCode([]);
        }
      });
    if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
      const API_URL = `/preauction/Common/BindSessionType`;
      const dt =
        baseUrlEng === "EnglishAuctionKutchaCatalogue" ? "ENGLISH" : "BHARAT";
      axiosMain.get(API_URL + "?auctionTypeCode=" + dt, {}).then((res) => {
        if (res.data.message) {
          setsessiontyp(res.data.responseData);
        } else {
          setsessiontyp([]);
        }
      });
    }
    axiosMain
      .post("admin/mark/dropdown/getMark", { auctionCenterId: auctionCenterId })
      .then((res) => {
        if (res.data.message) {
          setMkCode(res.data.responseData);
        } else {
          setMkCode([]);
        }
      });
  }, []);
  useEffect(() => {
    console.log(baseUrlEng, "baseUrlEngbaseUrlEng");
    setMyCatalogForAuctioneer(
      userRole === "buyer"
        ? [
          // { title: "Season", name: "season" },
          // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
          // { title: "Mark", name: "markName", noneditable: true, type: "text" },
          {
            title: "Lot No",
            name: "lotNo",
            noneditable: true,
            type: "text",
          },
          {
            title: "Mark",
            name: "markName",
            noneditable: true,
            type: "text",
          },
          {
            title: "Grade",
            name: "gradeName",
            noneditable: true,
            type: "text",
          },
          {
            title: "My Valuation",
            name: "myValuation",
            noneditable: false,
            type: "number",
          },
          {
            title: "My Comments",
            name: "myComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Group Code",
            name: "groupCode",
            noneditable: true,
            type: "select",
          },
        ]
        : baseUrlEng === "AuctionCatalog"
          ? [
            // { title: "Season", name: "season" },
            // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
            { title: "Mark", name: "Mark", noneditable: true, type: "text" },
            {
              title: "Lot No",
              name: "LotNo",
              noneditable: true,
              type: "text",
            },
            {
              title: "Base Price *",
              name: "basePrice",
              noneditable: false,
              type: "number",
            },
            {
              title: "Reserve Price *",
              name: "reservePrice",
              noneditable: false,
              type: "number",
            },
            {
              title: "Auctioneer's Valuation *",
              name: "auctioneerValuation",
              noneditable: false,
              type: "number",
            },

            // { title: "Auction Date", name: "auctionDate" },
            // { title: "Auction Date", name: "auctionDate" },
            // { title: "Tea Type", name: "teaTypeName" },
            // { title: "Category", name: "categoryName" },
            // { title: "Session Time", name: "sessionTime" },
            // { title: "Lot No.", name: "LotNo" },
            // { title: "Invoice No.", name: "invoiceNo" },
            // { title: "Origin", name: "Origin" },
            // { title: "Tea Type", name: "teaTypeName" },
            // { title: "Sub Type", name: "subTeaTypeName" },
            // { title: "Category", name: "categoryName" },
            // { title: "Grade", name: "gradeName" },
            // { title: "No. of Packages", name: "noOfPackages" },
            {
              title: "Mark & Packaging Comments",
              name: "markPackageComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Lot Comments",
              name: "lotComments",
              noneditable: false,
              type: "text",
            },
            {
              title: "Gross Weight *",
              name: "grossKgs",
              noneditable: false,
              type: "number",
            },
            {
              title: "Tare Weight *",
              name: "tareKgs",
              noneditable: false,
              type: "number",
            },
            {
              title: "Package No. *",
              name: "packageNo",
              noneditable: false,
              type: "text",
            },
            {
              title: "Total Packages *",
              name: "totalPackages",
              noneditable: false,
              type: "number",
            },
            // { title: "Net Weight", name: "netKgs" },
            {
              title: "Sample Qty. (KGs)",
              name: "SampleQty",
              noneditable: false,
              type: "number",
            },
            {
              title: "Quality Comments",
              name: "qualityComments",
              noneditable: false,
              type: "text",
            },
            // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
            // { title: "GP No.", name: "gpNo",noneditable:false },
            // { title: "GP Date", name: "gpDate",noneditable:false },
            // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
            {
              title: "Price Increment *",
              name: "priceIncrement",
              noneditable: false,
              type: "number",
            },
            // { title: "Market Type", name: "marketTypeName",noneditable:false },
            // { title: "Package Type", name: "packageType",noneditable:false },
            // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
            {
              title: "Garden Certification *",
              name: "gardenCertification",
              noneditable: false,
              type: "text",
            },
            {
              title: "Quality Certification",
              name: "qualityCertification",
              noneditable: false,
              type: "text",
            },
            {
              title: "Age of the Tea (In Months) *",
              name: "ageOfProducts",
              noneditable: false,
              type: "number",
            },
            {
              title: "Color of Brew",
              name: "brewColor",
              noneditable: false,
              type: "text",
            },
            // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
            {
              title: "Brewers Comments",
              name: "brewersComments",
              noneditable: false,
              type: "text",
            },
            // {
            //   title: "System Base Price",
            //   name: "SystemBasePrice",
            //   noneditable: true,
            //   type: "number",
            // },
            { title: "LSP / SP", name: "LSP_SP", noneditable: true },
            { title: "System Base Price", name: "SBP", noneditable: true },
            {
              title: "Short Excess Weight",
              name: "shortExcessWeight",
              noneditable: false,
              type: "text",
            },
          ]
          : baseUrlEng === "EnglishAuctionCatalog"
            ? // baseUrlEng === "EnglishAuctionKutchaCatalogue"
            [
              // { title: "Season", name: "season" },
              // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
              // { title: "Mark", name: "markName", noneditable: true, type: "text" },
              {
                title: "Lot No",
                name: "LotNo",
                noneditable: true,
                type: "text",
              },
              {
                title: "Mark",
                name: "markName",
                noneditable: false,
                type: "select",
              },
              {
                title: "Base Price",
                name: "basePrice",
                noneditable: false,
                type: "number",
              },
              {
                title: "Reserve Price",
                name: "reservePrice",
                noneditable: false,
                type: "number",
              },
              {
                title: "Auctioneer's Valuation",
                name: "auctioneerValuation",
                noneditable: false,
                type: "number",
              },

              {
                title: "Session Type",
                name: "sessionTypeName",
                noneditable: true,
                type: "select",
              },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Lot Comments",
                name: "lotComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Gross Weight",
                name: "grossKgs",
                noneditable: false,
                type: "number",
              },
              {
                title: "Tare Weight",
                name: "tareKgs",
                noneditable: false,
                type: "number",
              },
              {
                title: "Category",
                name: "categoryName",
                noneditable: true,
                type: "text",
              },
              {
                title: "Package No.",
                name: "packageNo",
                noneditable: false,
                type: "text",
              },
              // { title: "Tare Weight", name: "tareKgs" },
              // { title: "Net Weight", name: "netKgs" },

              {
                title: "Sample Qty. (KGs)",
                name: "SampleQty",
                noneditable: false,
                type: "number",
              },
              {
                title: "Total Package",
                name: "totalPackages",
                noneditable: false,
                type: "number",
              },
              {
                title: "Quality Comments",
                name: "qualityComments",
                noneditable: false,
                type: "text",
              },
              {
                title: "Short Excess Weight",
                name: "shortExcessWeight",
                noneditable: true,
                type: "text",
              },

              // { title: "Auction Date", name: "auctionDate" },
              // { title: "Auction Date", name: "auctionDate" },
              // { title: "Tea Type", name: "teaTypeName" },
              // { title: "Category", name: "categoryName" },
              // { title: "Session Time", name: "sessionTime" },
              // { title: "Lot No.", name: "LotNo" },
              // { title: "Invoice No.", name: "invoiceNo" },
              // { title: "Origin", name: "Origin" },
              // { title: "Tea Type", name: "teaTypeName" },
              // { title: "Sub Type", name: "subTeaTypeName" },
              // { title: "Category", name: "categoryName" },
              // { title: "Grade", name: "gradeName" },
              // { title: "No. of Packages", name: "noOfPackages" },

              // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
              // { title: "GP No.", name: "gpNo",noneditable:false },
              // { title: "GP Date", name: "gpDate",noneditable:false },
              // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
              // {
              //   title: "Price Increment",
              //   name: "priceIncrement",
              //   noneditable: false,
              //   type: "number",
              // },
              // { title: "Market Type", name: "marketTypeName",noneditable:false },
              // { title: "Package Type", name: "packageType",noneditable:false },
              // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
              // {
              //   title: "Garden Certification",
              //   name: "gardenCertification",
              //   noneditable: false,
              //   type: "text",
              // },
              // {
              //   title: "Quality Certification",
              //   name: "qualityCertification",
              //   noneditable: false,
              //   type: "text",
              // },
              // {
              //   title: "Age of the Tea (In Months)",
              //   name: "ageOfProducts",
              //   noneditable: false,
              //   type: "number",
              // },
              // {
              //   title: "Color of Brew",
              //   name: "brewColor",
              //   noneditable: false,
              //   type: "text",
              // },
              // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
              // {
              //   title: "Brewers Comments",
              //   name: "brewersComments",
              //   noneditable: false,
              //   type: "text",
              // },
              // {
              //   title: "System Base Price",
              //   name: "SystemBasePrice",
              //   noneditable: true,
              //   type: "number",
              // },
              // { title: "LSP / SP", name: "LSP_SP", noneditable: true },
              // { title: "System Base Price", name: "SBP_LSP_SP" },
            ]
            : baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? [
                // { title: "Season", name: "season" },
                // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
                // { title: "Mark", name: "markName", noneditable: true, type: "text" },
                {
                  title: "Lot No",
                  name: "LotNo",
                  noneditable: true,
                  type: "text",
                },
                {
                  title: "Mark",
                  name: "markName",
                  noneditable: true,
                  type: "text",
                },
                {
                  title: "Base Price",
                  name: "basePrice",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Reserve Price",
                  name: "reservePrice",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Auctioneer's Valuation",
                  name: "auctioneerValuation",
                  noneditable: false,
                  type: "number",
                },

                {
                  title: "Session Type",
                  name: "sessionTypeName",
                  noneditable: false,
                  type: "select",
                },
                {
                  title: "Mark & Packaging Comments",
                  name: "markPackageComments",
                  noneditable: false,
                  type: "text",
                },
                {
                  title: "Lot Comments",
                  name: "lotComments",
                  noneditable: false,
                  type: "text",
                },
                {
                  title: "Gross Weight",
                  name: "grossKgs",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Tare Weight",
                  name: "tareKgs",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Category",
                  name: "categoryName",
                  noneditable: true,
                  type: "text",
                },
                {
                  title: "Package No.",
                  name: "packageNo",
                  noneditable: false,
                  type: "text",
                },
                // { title: "Tare Weight", name: "tareKgs" },
                // { title: "Net Weight", name: "netKgs" },

                {
                  title: "Sample Qty. (KGs)",
                  name: "SampleQty",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Total Package",
                  name: "totalPackages",
                  noneditable: false,
                  type: "number",
                },
                {
                  title: "Quality Comments",
                  name: "qualityComments",
                  noneditable: false,
                  type: "text",
                },
                {
                  title: "Short Excess Weight",
                  name: "shortExcessWeight",
                  noneditable: true,
                  type: "text",
                },

                {
                  title: "Remarks",
                  name: "remarks",
                  noneditable: false,
                  type: "text",
                },
              ]
              : []
    );
    if (userRole === "buyer") {
      console.log(getDataByPrems, "getDataByPremsgetDataByPrems");
      formik.setValues(getDataByPrems);
      setgroupcodedisable(getDataByPrems?.groupCode);
    } else {
      if (getDataByPrems?.length > 0) {
        if (
          (getDataByPrems?.at(0)?.hours_date_difference < 48 &&
            baseUrlEng === "AuctionCatalog") ||
          (baseUrlEng === "EnglishAuctionCatalog" &&
            getDataByPrems?.at(0)?.hours_date_difference < 24) ||
          (baseUrlEng === "EnglishAuctionKutchaCatalogue" &&
            getDataByPrems?.at(0)?.hours_date_difference < 24)
        ) {
          let data = [...myCatalogForAuctioneer];
          data?.filter((ele) =>
            ele.name === "reservePrice"
              ? (ele.noneditable =
                baseUrlEng === "EnglishAuctionKutchaCatalogue" ||
                  baseUrlEng === "EnglishAuctionCatalog"
                  ? getDataByPrems?.at(0)?.isEditable === 0
                    ? true
                    : false
                  : getDataByPrems?.at(0)?.minute_difference >= 15
                    ? false
                    : true)
              : (ele.noneditable = true)
          );
          setMyCatalogForAuctioneer(data);
        }

        formik.setValues(getDataByPrems?.at(0));
        formik.setFieldValue(
          "markName",
          getDataByPrems?.at(0)?.markId === null
            ? ""
            : getDataByPrems?.at(0)?.markId
        );
        formik.setFieldValue(
          "lotComments",
          getDataByPrems?.at(0)?.markPackageComments === null
            ? ""
            : getDataByPrems?.at(0)?.lotComments
        );
        formik.setFieldValue(
          "markPackageComments",
          getDataByPrems?.at(0)?.markPackageComments === null
            ? ""
            : getDataByPrems?.at(0)?.markPackageComments
        );
        formik.setFieldValue(
          "sessionTypeName",
          getDataByPrems?.at(0)?.sessionTypeName === null ||
            getDataByPrems?.at(0)?.sessionTypeName === "-"
            ? ""
            : getDataByPrems?.at(0)?.sessionTypeName
        );
        if (baseUrlEng === "EnglishAuctionCatalog") {
          formik.setFieldValue(
            "priceIncrement",
            getDataByPrems?.at(0).priceIncrement === undefined ||
              getDataByPrems?.at(0).priceIncrement === null
              ? 1
              : getDataByPrems?.at(0).priceIncrement
          );
        }
        if (
          baseUrlEng === "EnglishAuctionCatalog" ||
          baseUrlEng === "EnglishAuctionKutchaCatalogue"
        ) {
          formik.setFieldValue(
            "totalPackages",
            getDataByPrems?.at(0)?.totalPackages
          );
        }
        //
        if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
          formik.setFieldValue("remarks", getDataByPrems?.at(0)?.remarks);
        }
      } else {
        formik.setValues({
          saleNo: "",
          markName: "",
          basePrice: "",
          auctioneerValuation: "",
          reservePrice: "",
          markPackageComments: "",
          lotComments: "",
          grossKgs: "",
          packageNo: "",
          SampleQty: "",
          qualityComments: "",
          priceIncrement: "",
          gardenCertification: "",
          qualityCertification: "",
          brewColor: "",
          ageOfProducts: "",
          brewersComments: "",
          SystemBasePrice: "",
          SBP_LSP_SP: "",
        });
      }
    }
  }, [getDataByPrems]);
  const [groupcodedisable, setgroupcodedisable] = useState("");
  return (
    <>
      <Modal
        size="xl"
        title="Update Valuation"
        show={openUploadUpdateValuation}
        handleClose={() => {
          setGetDataByprems([]);
          setOpenUploadUpdateValuation(false);
          formik.resetForm();
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            {myCatalogForAuctioneer?.length > 0
              ? myCatalogForAuctioneer
                .map((ele) =>
                  (baseUrlEng === "EnglishAuctionKutchaCatalogue" &&
                    ele.name === "reservePrice") ||
                    (baseUrlEng === "EnglishAuctionCatalog" &&
                      ele.name === "reservePrice")
                    ? {
                      ...ele,
                      noneditable:
                        getDataByPrems?.at(0)?.isEditable === 0
                          ? true
                          : getDataByPrems?.at(0)?.hours_date_difference <
                            24
                            ? false
                            : getDataByPrems?.at(0)?.hours_date_difference <
                            24,
                    }
                    : ele
                )
                ?.filter((ele) =>
                  baseUrlEng === "EnglishAuctionKutchaCatalogue" ||
                    baseUrlEng === "EnglishAuctionCatalog"
                    ? ele.name !== "priceIncrement"
                    : ele
                )
                ?.filter((ele) =>
                  baseUrlEng === "EnglishAuctionCatalog"
                    ? ele.name !== "sessionTypeName"
                    : ele
                )
                ?.map((field, index) => (
                  <div className="col-lg-2" key={index}>
                    <div className="FormGroup">
                      <label htmlFor={field.name}>{field.title?.includes("*") ? (<>{field.title?.split("*")?.join("")}<span style={{ color: "#dc3545" }}> *</span></>) : field.title}</label>
                      {field.type !== "select" &&
                        field.name !== "packageNo" && (
                          <>
                            <input
                              type={field.type}
                              id={field.name}
                              name={field.name}
                              className="form-control select-form"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values[field.name]}
                              disabled={
                                // (field.name === "lotComments" || (field.name === "groupCode" && groupcodedisable === "-")) ? false :
                                field.noneditable
                              }
                            />
                          </>
                        )}
                      {field.type === "select" &&
                        field.name === "groupCode" && (
                          <>
                            <select
                              type={field.type}
                              id={field.name}
                              name={field.name}
                              className="form-control select-form"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values[field.name]}
                            >
                              <option value="">Select</option>
                              {group?.map((item) => (
                                <option value={item.groupCode}>
                                  {item.groupCode}
                                </option>
                              ))}
                              {/* Add options for dropdown */}
                            </select>
                          </>
                        )}
                      {field.type === "select" &&
                        field.name === "markName" && (
                          <>
                            <select
                              type={field.type}
                              id={field.name}
                              name={field.name}
                              disabled={field.noneditable
                              }
                              className="form-control select-form"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values[field.name]}
                            >
                              <option value="">Select</option>
                              {mkCode?.map((item) => (
                                <option value={item.markId}>
                                  {item.markCode}
                                </option>
                              ))}
                              {/* Add options for dropdown */}
                            </select>
                          </>
                        )}
                      {/* new add */}
                      {field.type === "text" &&
                        field.name === "packageNo" && (
                          <>
                            <input
                              type={field.type}
                              id={field.name}
                              name={field.name}
                              className="form-control select-form"
                              onInput={(e) => fnpackegechange(e)}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values[field.name]}
                              disabled={
                                // (field.name === "lotComments" || (field.name === "groupCode" && groupcodedisable === "-")) ? false :
                                field.noneditable
                              }
                            />
                          </>
                        )}

                      {field.type === "select" &&
                        field.name === "sessionTypeName" && (
                          <>
                            <select
                              type={field.type}
                              id={field.name}
                              name={field.name}
                              className="form-control select-form"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values[field.name]}
                              disabled={field.noneditable}
                            >
                              <option value="">Select</option>
                              {sessiontyp?.map((item) => (
                                <option value={item.sessionTypeName}>
                                  {item.sessionTypeName}
                                </option>
                              ))}
                              {/* Add options for dropdown */}
                            </select>
                          </>
                        )}
                      <small className="text-danger">
                        {formik.touched[field.name] &&
                          formik.errors[field.name]
                          ? formik.errors[field.name]
                          : null}
                      </small>
                    </div>
                  </div>
                ))
              : ""}
          </div>

          {userRole === "buyer" ? (
            <button
              type="submit"
              className="SubmitBtn"
              style={{ borderRadius: ".25rem" }}
            >
              Update Valuation
            </button>
          ) : (
            <button
              type="submit"
              disabled={
                baseUrlEng === "EnglishAuctionCatalog" ||
                  baseUrlEng === "EnglishAuctionKutchaCatalogue"
                  ? getDataByPrems?.at(0)?.isEditable === 0
                    ? true
                    : false
                  : //  getDataByPrems?.at(0)?.minute_difference >= 15
                  // ? false
                  // : true
                  getDataByPrems?.at(0)?.minute_difference >= 15
                    ? false
                    : true
              }
              className="SubmitBtn"
              style={{ borderRadius: ".25rem" }}
            >
              {baseUrlEng !== "EnglishAuctionKutchaCatalogue"
                ? "Submit"
                : "Update Valuation"}
            </button>
          )}
        </form>
      </Modal>

      {/* confirmation model */}
      <Modals
        show={openModalConformation}
        size="xl"
        // onHide={() => setShow(false)}
        handleClose={() => {
          setOpenModalConformation(false);
          setDataFlag(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title="Confirmation Message"
      >
        <div>
          <ul>{openModalConformationTitle}</ul>
        </div>
        {baseUrlEng === "EnglishAuctionKutchaCatalogue" && (
          <>
            <br />
            <div>
              <ul>
                ● If you want the system to automatically delete the associated
                sample and shortage data for the packages click{" "}
                <b>Yes, Delete and Proceed</b>
              </ul>

              <ul>
                ● If you want to keep the existing sample and shortage data and
                delete package no. manually, click <b>NO, Manually Delete</b>
              </ul>
            </div>
          </>
        )}
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          {baseUrlEng === "EnglishAuctionKutchaCatalogue" ? (
            <>
              <button
                // className="SubmitBtn"
                className="SubmitBtn"
                type="button"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                Yes, Delete and Proceed
              </button>

              <button
                type="button"
                className="SubmitBtn"
                // className="SubmitBtn"
                onClick={() => {
                  setDataFlag(false);
                  setOpenModalConformation(false);
                }}
              >
                NO, Manually Delete
              </button>
            </>
          ) : (
            <>
              <button
                // className="SubmitBtn"
                className="SubmitBtn"
                type="button"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                Yes
              </button>

              <button
                type="button"
                className="SubmitBtn"
                // className="SubmitBtn"
                onClick={() => {
                  setDataFlag(false);
                  setOpenModalConformation(false);
                }}
              >
                No
              </button>
            </>
          )}
        </div>
      </Modals>
    </>
  );
};

export default UpdateValuation;
